/** @jsxImportSource @emotion/react */
import { Global, Theme, ThemeProvider } from '@emotion/react';
import type { ReactNode } from 'react';
import { Provider as ReakitProvider } from 'reakit';
import { theme as theme10 } from '../theme';

type ProviderProps = {
  children: ReactNode;
  theme?: Theme;
};

function Provider({ children, theme = theme10 }: ProviderProps) {
  return (
    <ReakitProvider>
      <ThemeProvider theme={theme}>
        <Global
          styles={{
            body: {
              background: theme?.colors.body,
            },
          }}
        />
        <div
          css={{
            color: theme?.colors['gray-90'],
            fontSize: theme?.fontSizes['textBase'],
            lineHeight: theme?.lineHeights['textBaseLineHeight'],
          }}
        >
          {children}
        </div>
      </ThemeProvider>
    </ReakitProvider>
  );
}

export { Provider };
